<template>    
    <v-app>        
        <navigation-menu></navigation-menu>
        <v-main>
            <router-view></router-view>
        </v-main>
        <v-snackbar bottom right outlined multi-line style="white-space: pre-line" v-model="notification.visibility" :color="notification.color" :timeout="notification.timeout">
            {{ notification.text }}
            <template v-slot:action="{ attrs }">
                <v-btn dark text v-bind="attrs" @click="notification.visibility = false" :color="notification.color">
                    <v-icon color="error">mdi-close</v-icon>
                </v-btn>
            </template>
        </v-snackbar>
        <progress-component></progress-component>        
    </v-app>
</template>

<script>
    import { mapActions, mapState } from 'vuex';
    import NavigationMenu from './shared/NavigationMenu.vue'
    import progressComponent from './shared/progress-component.vue';

    export default {
        name: 'App',
        components: {
            NavigationMenu,progressComponent
        },
        data: () => ({}),
        methods: {
            ...mapActions('configuration', ['resetConfiguration']),
            ...mapActions('notifications',  ['clear']),            
            /**
             * Solo en el caso en que quisieramos ocultarlo en una determinada ruta.
             */
            isShow(){
                return (this.$route.fullPath != '/') ? true : false;
            }
        },
        computed: {
            ...mapState('notifications', ['notification']),
            ...mapState('configuration', ['configuration']),
            ...mapState('authentication', ['isLoggedIn']),
        },
        mounted() {
            if(this.isLoggedIn == false) {
                // this.resetConfiguration();
            }
        },
        beforeMount (){
            this.clear();
        },
        watch : {
            isLoggedIn : function (nvl){
                if(this.$route.fullPath != '/login'){
                    nvl == false ? this.$router.push({'name' : "login"}) : void(0);
                }
            },
        }
    }
</script>
